const CONFIGURED_ENDPOINT =
  process.env.NEXT_PUBLIC_AGENT_INGEST_ENDPOINT ||
  process.env.EXPO_PUBLIC_AGENT_INGEST_ENDPOINT ||
  process.env.AGENT_INGEST_ENDPOINT ||
  null;

const AGENT_ENDPOINT = CONFIGURED_ENDPOINT;

function logAgent(details, fallback) {
  const payload = { ...details, timestamp: details.timestamp ?? Date.now() };
  if (AGENT_ENDPOINT) {
    if (typeof fetch !== 'function') return;
    fetch(AGENT_ENDPOINT, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
    }).catch(() => {});
    return;
  }
  if (fallback) {
    fallback(payload).catch(() => {});
  }
}

module.exports = {
  logAgent,
};
